import { Component, OnInit, ViewChild } from "@angular/core";
import { Categoria } from "../models/categoria";
import { Filtro } from "../models/filtro";
import { MatPaginator, PageEvent } from "@angular/material";
import { UtilitarioService } from "../services/utilitario.service";
import { ActivatedRoute, Router } from "@angular/router";
import { PaginatorService } from "../services/paginator.service";
import { CarregandoService } from "../services/carregando.service";
import { NotificacaoService } from "../services/notificacao.service";
import { CategoriaService } from "../services/categoria.service";
import { OrigemGI } from "../models/enum";
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FvEtapaFunilModel } from '../orcamento/models/fv-etapa-funil-model';

@Component({
  selector: "app-categoria",
  templateUrl: "./categoria.component.html",
  styleUrls: ["./categoria.component.scss"],
})
export class CategoriaComponent implements OnInit {
  categorias: Categoria[] = [];
  carregando = true;
  campoOrdenacao = "id";
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: "descricao", Valor: "" };
  filtros: Filtro[] = [this.filtroNome];
  status = [
    { id: 2, descricao: "Todos" },
    { id: 1, descricao: "Ativo" },
    { id: 0, descricao: "Bloqueado" },
  ];
  statusSelecionado = 1;
  origens = [
    { id: OrigemGI.KitCustomizado, descricao: "Kit Customizado" },
    { id: OrigemGI.KitFechado, descricao: "Kit Fechado" },
    { id: OrigemGI.Avulso, descricao: "Avulso" },
    { id: OrigemGI.LojaProdutos, descricao: "Loja de Produtos" }
  ];
  origensSelecionadas: number[] = null;

  @ViewChild("paginator", { static: false }) paginator: MatPaginator;

  constructor(
    private categoriaService: CategoriaService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private paginatorService: PaginatorService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarCategorias();
  }

  nova() {
    this.router.navigate(["novo"], { relativeTo: this.route });
  }

  editar(categoria: Categoria) {
    this.router.navigate(["editar", categoria.id], { relativeTo: this.route });
  }

  buscarCategoriasPaginada() {
    this.carregandoService.mostra("buscarCategoriasPaginada");
    this.carregando = true;

    this.categoriaService
      .consultarComPaginacao(
        this.filtroNome.Valor,
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc ? "desc" : "asc",
        this.statusSelecionado,
        this.origensSelecionadas
      )
      .subscribe(
        (data: any) => {
          this.categorias = data.itens;
          this.listaDeItensPorPagina =
            this.utilitarioService.calculaItensPorPagina(data.total);

          if (
            this.itensPorPagina >
            this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]
          ) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = data.total;

          this.carregando = false;
          this.carregandoService.esconde("buscarCategoriasPaginada");
        },
        (erro) => {
          this.carregandoService.esconde("buscarCategoriasPaginada");
          this.notificacaoService.erro(erro);
        }
      );
  }

  buscarCategorias() {
    this.carregandoService.mostra("buscaCategorias");
    this.carregando = true;

    this.categoriaService
      .listar(this.statusSelecionado)
      .subscribe(
        (data: any) => {
          this.categorias = data;

          this.carregando = false;
          this.carregandoService.esconde("buscaCategorias");
        },
        (erro) => {
          this.carregandoService.esconde("buscaCategorias");
          this.notificacaoService.erro(erro);
        }
      );
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarCategoriasPaginada();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.categorias = this.categorias.sort((a, b) => {
        const isAsc = !this.ordenarDesc;

        switch (this.campoOrdenacao) {
          case "descricao":
            return this.compare(a.descricao, b.descricao, isAsc);
          default:
            return 0;
        }
      });

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  filtra() {
    this.buscarCategoriasPaginada();
    this.paginator.firstPage();
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === "string") {
      a = a.toLowerCase();
    }

    if (typeof b === "string") {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  softDelete(categoria: Categoria) {
    this.carregandoService.mostra("softDelete");

    this.categoriaService.softDelete(categoria.id).subscribe(
      (data) => {
        this.notificacaoService.sucesso("Categoria excluída com sucesso!");
        this.carregandoService.esconde("softDelete");
        this.filtra();
      },
      (erro) => {
        this.carregandoService.esconde("softDelete");
        this.notificacaoService.erro("Não foi possível excluir a categoria.");
      }
    );
  }

  excluir(id) {
    this.carregandoService.mostra("excluir");

    this.categoriaService.excluir(id).subscribe(data => {
      this.carregandoService.esconde('excluir');
      this.buscarCategorias();
    }, (erro) => {
      this.carregandoService.esconde('excluir');
      this.notificacaoService.erro(erro);
    });
  }

  drop(event: CdkDragDrop<Categoria[]>) {
    moveItemInArray(this.categorias, event.previousIndex, event.currentIndex);

    this.categorias.forEach((categoria, index) => {
      categoria.ordem = index;

      this.salvarOrdem(categoria.id, categoria.ordem);
    });
  }

  salvarOrdem(idCategoria, ordem) {
    this.carregandoService.mostra('salvarOrdem');
    this.categoriaService.atualizaOrdem(idCategoria, ordem).subscribe(() => {
      this.carregandoService.esconde('salvarOrdem');
    }, (erro) => {
      this.carregandoService.esconde('salvarOrdem');
      this.notificacaoService.erro(erro);
    });
  }
}
